function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { gridColumnDefinitionsSelector, gridVisibleColumnDefinitionsSelector } from "../columns/index.js";
import { gridFilteredSortedRowIdsSelector } from "../filter/index.js";
import { gridPinnedRowsSelector, gridRowTreeSelector } from "../rows/gridRowsSelector.js";
export var getColumnsToExport = function(param) {
    var apiRef = param.apiRef, options = param.options;
    var columns = gridColumnDefinitionsSelector(apiRef);
    if (options.fields) {
        return options.fields.reduce(function(currentColumns, field) {
            var column = columns.find(function(col) {
                return col.field === field;
            });
            if (column) {
                currentColumns.push(column);
            }
            return currentColumns;
        }, []);
    }
    var validColumns = options.allColumns ? columns : gridVisibleColumnDefinitionsSelector(apiRef);
    return validColumns.filter(function(column) {
        return !column.disableExport;
    });
};
export var defaultGetRowsToExport = function(param) {
    var apiRef = param.apiRef;
    var _bodyRows, _bodyRows1;
    var _pinnedRows_top, _pinnedRows_bottom;
    var filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
    var rowTree = gridRowTreeSelector(apiRef);
    var selectedRows = apiRef.current.getSelectedRows();
    var bodyRows = filteredSortedRowIds.filter(function(id) {
        return rowTree[id].type !== 'footer';
    });
    var pinnedRows = gridPinnedRowsSelector(apiRef);
    var topPinnedRowsIds = (pinnedRows === null || pinnedRows === void 0 ? void 0 : (_pinnedRows_top = pinnedRows.top) === null || _pinnedRows_top === void 0 ? void 0 : _pinnedRows_top.map(function(row) {
        return row.id;
    })) || [];
    var bottomPinnedRowsIds = (pinnedRows === null || pinnedRows === void 0 ? void 0 : (_pinnedRows_bottom = pinnedRows.bottom) === null || _pinnedRows_bottom === void 0 ? void 0 : _pinnedRows_bottom.map(function(row) {
        return row.id;
    })) || [];
    (_bodyRows = bodyRows).unshift.apply(_bodyRows, _to_consumable_array(topPinnedRowsIds));
    (_bodyRows1 = bodyRows).push.apply(_bodyRows1, _to_consumable_array(bottomPinnedRowsIds));
    if (selectedRows.size > 0) {
        return bodyRows.filter(function(id) {
            return selectedRows.has(id);
        });
    }
    return bodyRows;
};
